import { active } from "@api/stores/measurementUnits/active/api";
import { deactive } from "@api/stores/measurementUnits/deactive/api";
import { stats } from "@api/stores/measurementUnits/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IMeasurementUnitsDto,
  IMeasurementUnitsGetAllParams,
  IMeasurementUnitsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IMeasurementUnitsResponse>>,
  IPathBaseParam,
  IPaginationParams & IMeasurementUnitsGetAllParams
>("stores.measurementUnits");
const postApis = createPostApi<
  IApiResponse<IMeasurementUnitsResponse>,
  IPathBaseParam,
  IMeasurementUnitsDto
>("stores.measurementUnits");
const getApis = createGetApi<
  IApiResponse<IMeasurementUnitsResponse>,
  IPathByIdParam,
  object
>("stores.measurementUnits");
const patchApis = createPatchApi<
  IApiResponse<IMeasurementUnitsResponse>,
  IPathByIdParam,
  IMeasurementUnitsDto
>("stores.measurementUnits");

export const measurementUnits = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  active,
  deactive,
  stats,
};
